import type { FaireProductEntity } from "../../entity_types/product";

export const p_rnbqmsvr3t: FaireProductEntity = {
  token: "p_rnbqmsvr3t",
  type: "product",
  name: 'Oversized Mug with Cats-4"H(17oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/c63cde2139aa69abd8e1af6d67501677b7e1ee93bcfbd746c4fa463ca207c86f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/68eb320a184d996054cb28e5ee144b49585246e78b3db31e352603a5909b31c6.jpeg",
    "https://cdn.faire.com/fastly/61a07c56a12b78f512ca05562c0c5c7765f5761689618f44ca49c40898c46c24.jpeg",
    "https://cdn.faire.com/fastly/cc3ffe5d99f678dc02b6d7d1b5e160a72b5afd9b9b43158c3dc2919570137b50.jpeg",
    "https://cdn.faire.com/fastly/b2fe8d235f76e81c0e7b99527c0e2493476c700df61e6e795c94a2dfdba3b279.jpeg",
  ],
  priceDollars: 5,
  description:
    "An oversized mug adorned with playful cat faces offers a whimsical touch to your coffee or tea routine. Made of durable stoneware, its large capacity is perfect for cozy, generous servings. The adorable feline expressions bring charm and warmth, making it an ideal gift for cat lovers and a delightful addition to any kitchen.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:15.005Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
